import mock from '../mockConfig';
import { citiesData } from '../../@fake-db';
let cities = citiesData.cities;

mock.onGet('/cities').reply(request => {

  return [200, cities];
});